import { jsPDF as JsPdf } from 'jspdf';
import { saveAs } from 'file-saver-es';
import { Workbook } from 'exceljs';
import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import { exportDataGrid as exportDataGridToXLSX } from 'devextreme/excel_exporter';

export const onExporting = (e) => {
    if (e.format === 'pdf') {
        const doc = new JsPdf();
        exportDataGridToPdf({
            jsPDFDocument: doc,
            component: e.component,
        }).then(() => {
            doc.save('Export.pdf');
        });
    } else {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Table');

        exportDataGridToXLSX({
            component: e.component,
            worksheet,
            autoFilterEnabled: true,
        }).then(() => {
            workbook.xlsx.writeBuffer().then((buffer) => {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Export.xlsx');
            });
        });
        e.cancel = true;
    }
};